import {
  Component,
  OnInit,
  AfterViewChecked,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Location, DecimalPipe, DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { conformToMask } from "text-mask-core";
import { FileUpload } from "../../model/domain/File";
import { DateTime } from "luxon";

import { TicketService } from "../../services/ticket.service";
import { ValidatorService } from "../../services/validator.service";
import { DialogService } from "../../services/dialog.service";
import { SnackbarService } from "../../services/snackbar.service";
import { LoaderService } from "../../services/loader.service";
import { UploadTo } from "../../model/domain/UploadTo";
import { FileService } from "../../services/file.service";
import { UploadWfHistoryComponent } from "./upload-wf-history.component";
import { MatDialog } from "@angular/material/dialog";
import { DownloadService } from "../../services/download.service";
import { PagedList } from "../../model/domain/PagedList";
import { AuthService } from "../../services/auth.service";
import { Roles } from "../auth/auth.role";
import { WorkflowService } from "../../services/workflow.service";

@Component({
  selector: "app-upload-to",
  templateUrl: "./upload-to.component.html",
  styleUrls: ["./upload-to.component.scss"],
})
export class UploadTransferOrdeComponent implements OnInit, AfterViewChecked {
  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private service: TicketService,
    private snackBarService: SnackbarService,
    private loaderService: LoaderService,
    private fileService: FileService,
    private dialogService: DialogService,
    private downloadService: DownloadService,
    private authService: AuthService,
    private workflowService: WorkflowService
  ) {}

  @ViewChild("thisForm") public frm: NgForm;
  @ViewChild("thisInput") inputFile: ElementRef;
  file: File;

  // Paginação
  defaultPage = 1;
  defaultPageSize = 10;
  pageSizeSelected = this.defaultPageSize;

  // Filtros
  Hoje: Date = new Date();
  PeriodoDe: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  PeriodoAte: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );

  uploadCurrentPage: number = this.defaultPage;
  uploadPageSize: number = this.defaultPageSize;
  uploadTotalPages: number = null;
  uploadTotalItems: number = null;
  uploadListedPages: any[];
  uploadFirstItemOnPage: number;
  uploadLastItemOnPage: number;

  Files: FileUpload[] = [];

  isEditing = false;
  canValidate = false;
  isReady = false;
  ngForm: NgForm;
  AccountManagers = [];

  model: UploadTo;

  afuConfig = null;

  validators = {};

  ColumnsFile: string[] = [
    "name",
    "createDate",
    "createUser",
    "workflowStatus",
    "actions",
  ];

  // Init
  ngOnInit() {
    this.validatorsInit();
    this.modelInit();
  }

  ngAfterViewChecked() {
    if (!this.isReady) {
      setTimeout(() => {
        if (!this.canEdit()) {
          Object.values(this.frm.controls).forEach((c) => {
            c.disable();
          });
        }
      }, 0);
      this.isReady = true;
    }
  }

  validatorsInit() {
    // Add validators
  }

  loadFilesPaged(page: number = null, pageSize: number = null) {
    const params: any[] = [];

    if (page) {
      params.push(page);
    } else {
      params.push(this.uploadCurrentPage);
    }

    if (pageSize) {
      params.push(pageSize);
      this.uploadPageSize = pageSize;
    } else if (this.uploadPageSize) {
      params.push(this.uploadPageSize);
    } else {
      params.push(this.defaultPageSize);
    }

    this.fileService
      .getFilesPaginated(page, pageSize)
      .subscribe((filesPaginated) => {
        if (filesPaginated && filesPaginated.results) {
          this.Files = filesPaginated && filesPaginated.results;
          this.renderPaginatorFile(filesPaginated);
        }
      });
  }

  modelInit() {
    this.model = new UploadTo();
    this.loadFilesPaged();
  }

  loadFiles(param0: any, param1: any) {
    this.fileService.getFiles().subscribe((q) => {
      this.Files = q;
    });
  }

  canEdit() {
    return true;
  }

  validateForm(f: NgForm): boolean {
    return true;
  }

  submit() {
    this.loaderService.addLoader();

    this.register(this.frm)
      .pipe(
        catchError((err) => {
          this.loaderService.removeLoader();

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
          return throwError(err);
        })
      )
      .subscribe(
        (r) => {
          this.loaderService.removeLoader();

          this.snackBarService.open("Upload realizado.", "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });

          this.clearFileInput();
        },
        () => {
          this.modelInit();
        }
      );
  }

  clearFileInput() {
    this.inputFile.nativeElement.value = "";
    this.file = null;
  }

  register(f: NgForm) {
    const data = Object.assign({}, this.model);
    return this.sendSubmit(data);
  }

  openFile(event) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  sendSubmit(data: UploadTo) {
    const method = this.service.TransferOrder.upload(this.file);

    return method
      .pipe(
        catchError((err) => {
          return throwError("Erro ao realizar upload.");
        })
      )
      .pipe(
        map((margin: UploadTo) => {
          this.modelInit();

          return this.model;
        })
      );
  }

  approve(id: number): void {
    this.dialogService
      .confirm("Aprovar Upload", "Deseja aprovar este upload?")
      .subscribe((result) => {
        if (result) {
          this.fileService.approve(id, "").subscribe((res) => {
            this.snackBarService.open("Upload aprovado.", "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });

            this.model.workflowStatus = res;
            this.modelInit();
          });
        }
      });
  }

  reject(id: number): void {
    this.dialogService
      .reject("Reprovar Upload", "Deseja reprovar o upload?")
      .subscribe((result) => {
        if (result) {
          this.fileService.reject(id, result.justification).subscribe((res) => {
            this.snackBarService.open("Upload cancelado com sucesso.", "OK", {
              verticalPosition: "top",
              horizontalPosition: "right",
            });
            this.model.workflowStatus = res;
            this.modelInit();
          });
        }
      });
  }

  showHistory(workflowId: number): void {
    this.dialog.open(UploadWfHistoryComponent, {
      width: "800px",
      data: { workflowId: workflowId },
    });
  }

  download(name: string) {
    const download = this.fileService.download(name);

    return download.subscribe(
      (data: Blob) => {
        const filename = `ordem_transferencia_${DateTime.local().toFormat(
          "yyyyMMdd"
        )}.xlsx`;
        this.downloadService.downloadFile(data, filename);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível fazer o download do arquivo.",
          "OK"
        );
      }
    );
  }

  renderPaginatorFile(result: PagedList<any>) {
    this.uploadTotalItems = result.rowCount;
    this.uploadTotalPages = result.pageCount;
    this.uploadFirstItemOnPage = result.firstRowOnPage;
    this.uploadLastItemOnPage = result.lastRowOnPage;

    this.uploadCurrentPage = result.currentPage;

    this.uploadListedPages = [];

    let startPage = this.uploadCurrentPage - 2;
    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.uploadCurrentPage + 2;
    while (maxPage > this.uploadTotalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.uploadListedPages.push(i);
    }

    if (!result.results.length) {
      this.uploadTotalPages = 1;
      this.uploadCurrentPage = 1;
      this.uploadFirstItemOnPage = 0;

      this.uploadListedPages = [];
      this.uploadListedPages.push(1);
    }
  }

  canViewMonitor() {
    const roles = [Roles.ViewUploadTransferMonitor];
    return this.authService.hasRoles(roles);
  }

  canUploadTransfer() {
    const roles = [Roles.UploadTransfer];
    return this.authService.hasRoles(roles);
  }

  canApproveUpload() {
    const roles = [Roles.ApproveUploadTransfer];
    return this.authService.hasRoles(roles);
  }
}
